import type { DefaultMantineColor, Tuple } from '@mantine/styles';

export const neutralColors = {
	white: '#FFFFFF',
	black: '#000000',
};

export type ExtendedCustomColors =
	| 'primary'
	| 'brand'
	| 'black-alpha'
	| 'white-alpha'
	| 'sunset'
	| DefaultMantineColor;

export const colors: Record<ExtendedCustomColors, Tuple<string, 10>> = {
	brand: [
		'#F56551',
		'#FBEEE6',
		'#FFBEB5',
		'#F99385',
		'#F56551',
		'#4A0901',
		'#4A0901',
		'#4A0901',
		'#4A0901',
		'#4A0901',
	],
	primary: [
		'#DCF6FF',
		'#AEE0FF',
		'#7ECAFF',
		'#4DB5FF',
		'#229FFE',
		'#0D86E5',
		'#0074C7',
		'#004A81',
		'#002D50',
		'#001020',
	],
	'black-alpha': [
		'rgba(0,0,0,0.00)',
		'rgba(0,0,0,0.03)',
		'rgba(0,0,0,0.05)',
		'rgba(0,0,0,0.08)',
		'rgba(0,0,0,0.12)',
		'rgba(0,0,0,0.16)',
		'rgba(0,0,0,0.20)',
		'rgba(0,0,0,0.24)',
		'rgba(0,0,0,0.48)',
		'rgba(0,0,0,1.00)',
	],
	blue: [
		'rgba(220,243,255,1.00)',
		'rgba(174,215,255,1.00)',
		'rgba(125,189,255,1.00)',
		'rgba(74,162,255,1.00)',
		'rgba(26,135,255,1.00)',
		'rgba(0,102,204,1.00)',
		'rgba(0,85,180,1.00)',
		'rgba(0,61,130,1.00)',
		'rgba(0,37,81,1.00)',
		'rgba(0,13,33,1.00)',
	],
	'cyan (legacy)': [
		'rgba(234,252,255,1.00)',
		'rgba(185,234,243,1.00)',
		'rgba(147,219,232,1.00)',
		'rgba(108,204,221,1.00)',
		'rgba(70,189,210,1.00)',
		'rgba(45,164,185,1.00)',
		'rgba(29,127,145,1.00)',
		'rgba(14,91,104,1.00)',
		'rgba(0,56,65,1.00)',
		'rgba(0,20,26,1.00)',
	],
	cyan: [
		'rgba(234,244,255,1.00)',
		'rgba(213,235,255,1.00)',
		'rgba(202,230,255,1.00)',
		'rgba(145,208,255,1.00)',
		'rgba(81,192,255,1.00)',
		'rgba(0,148,213,1.00)',
		'rgba(0,124,180,1.00)',
		'rgba(0,91,135,1.00)',
		'rgba(0,58,90,1.00)',
		'rgba(0,33,51,1.00)',
	],
	dark: [
		'rgba(221,221,221,1.00)',
		'rgba(176,176,176,1.00)',
		'rgba(158,158,158,1.00)',
		'rgba(102,102,102,1.00)',
		'rgba(54,54,54,1.00)',
		'rgba(38,38,38,1.00)',
		'rgba(32,32,32,1.00)',
		'rgba(25,25,25,1.00)',
		'rgba(22,22,22,1.00)',
		'rgba(18,18,18,1.00)',
	],
	grape: [
		'rgba(255,231,251,1.00)',
		'rgba(246,190,231,1.00)',
		'rgba(235,149,213,1.00)',
		'rgba(225,107,195,1.00)',
		'rgba(215,65,177,1.00)',
		'rgba(190,40,152,1.00)',
		'rgba(148,30,118,1.00)',
		'rgba(91,16,75,1.00)',
		'rgba(65,9,53,1.00)',
		'rgba(27,0,21,1.00)',
	],
	gray: [
		'rgba(252,252,252,1.00)',
		'rgba(247,247,247,1.00)',
		'rgba(241,241,241,1.00)',
		'rgba(235,235,235,1.00)',
		'rgba(221,221,221,1.00)',
		'rgba(204,204,204,1.00)',
		'rgba(138,138,138,1.00)',
		'rgba(110,110,110,1.00)',
		'rgba(74,74,74,1.00)',
		'rgba(34,34,34,1.00)',
	],
	green: [
		'rgba(226,253,234,1.00)',
		'rgba(189,240,203,1.00)',
		'rgba(152,230,172,1.00)',
		'rgba(112,218,139,1.00)',
		'rgba(73,207,107,1.00)',
		'rgba(48,182,81,1.00)',
		'rgba(34,135,59,1.00)',
		'rgba(22,101,43,1.00)',
		'rgba(8,62,24,1.00)',
		'rgba(0,22,2,1.00)',
	],
	indigo: [
		'rgba(234,233,255,1.00)',
		'rgba(193,193,245,1.00)',
		'rgba(153,152,232,1.00)',
		'rgba(113,111,221,1.00)',
		'rgba(72,70,210,1.00)',
		'rgba(47,45,185,1.00)',
		'rgba(36,35,145,1.00)',
		'rgba(24,25,105,1.00)',
		'rgba(13,14,65,1.00)',
		'rgba(4,4,28,1.00)',
	],
	lime: [
		'rgba(243,253,224,1.00)',
		'rgba(225,245,184,1.00)',
		'rgba(206,237,142,1.00)',
		'rgba(187,230,100,1.00)',
		'rgba(168,223,57,1.00)',
		'rgba(143,198,32,1.00)',
		'rgba(110,154,23,1.00)',
		'rgba(78,110,14,1.00)',
		'rgba(46,66,5,1.00)',
		'rgba(13,23,0,1.00)',
	],
	orange: [
		'rgba(255,241,227,1.00)',
		'rgba(255,223,174,1.00)',
		'rgba(255,202,125,1.00)',
		'rgba(255,181,75,1.00)',
		'rgba(255,160,26,1.00)',
		'rgba(230,134,0,1.00)',
		'rgba(173,101,0,1.00)',
		'rgba(129,75,0,1.00)',
		'rgba(79,44,0,1.00)',
		'rgba(31,13,0,1.00)',
	],
	pink: [
		'rgba(255,225,233,1.00)',
		'rgba(255,177,192,1.00)',
		'rgba(255,126,152,1.00)',
		'rgba(255,76,111,1.00)',
		'rgba(255,26,69,1.00)',
		'rgba(230,0,44,1.00)',
		'rgba(180,0,33,1.00)',
		'rgba(129,0,23,1.00)',
		'rgba(80,0,13,1.00)',
		'rgba(33,0,3,1.00)',
	],
	red: [
		'rgba(254,232,235,1.00)',
		'rgba(254,209,215,1.00)',
		'rgba(254,193,199,1.00)',
		'rgba(255,85,76,1.00)',
		'rgba(255,38,26,1.00)',
		'rgba(226,44,56,1.00)',
		'rgba(202,28,39,1.00)',
		'rgba(142,11,33,1.00)',
		'rgba(95,7,22,1.00)',
		'rgba(47,4,11,1.00)',
	],
	sand: [
		'rgba(250,247,244,1.00)',
		'rgba(240,239,233,1.00)',
		'rgba(223,221,215,1.00)',
		'rgba(0, 0, 0, 1.0)',
		'rgba(0, 0, 0, 1.0)',
		'rgba(212,201,191,1.00)',
		'rgba(0, 0, 0, 1.0)',
		'rgba(0, 0, 0, 1.0)',
		'rgba(0, 0, 0, 1.0)',
		'rgba(0, 0, 0, 1.0)',
	],
	sunset: [
		'rgba(255,231,226,1.00)',
		'rgba(255,190,181,1.00)',
		'rgba(249,147,133,1.00)',
		'rgba(245,101,81,1.00)',
		'rgba(0, 0, 0, 1.0)',
		'rgba(0, 0, 0, 1.0)',
		'rgba(169,29,10,1.00)',
		'rgba(122,20,6,1.00)',
		'rgba(74,9,1,1.00)',
		'rgba(31,0,0,1.00)',
	],
	teal: [
		'rgba(223,252,244,1.00)',
		'rgba(190,238,223,1.00)',
		'rgba(154,227,203,1.00)',
		'rgba(115,214,182,1.00)',
		'rgba(78,202,161,1.00)',
		'rgba(53,177,135,1.00)',
		'rgba(38,138,105,1.00)',
		'rgba(23,98,74,1.00)',
		'rgba(23,51,45,1.00)',
		'rgba(0,22,12,1.00)',
	],
	violet: [
		'rgba(252,247,255,1.00)',
		'rgba(246,229,255,1.00)',
		'rgba(206,147,237,1.00)',
		'rgba(186,105,227,1.00)',
		'rgba(166,62,218,1.00)',
		'rgba(150,39,206,1.00)',
		'rgba(109,28,151,1.00)',
		'rgba(79,18,109,1.00)',
		'rgba(48,9,67,1.00)',
		'rgba(20,1,27,1.00)',
	],
	'white-alpha': [
		'rgba(255,255,255,0.00)',
		'rgba(255,255,255,0.03)',
		'rgba(255,255,255,0.05)',
		'rgba(255,255,255,0.08)',
		'rgba(255,255,255,0.12)',
		'rgba(255,255,255,0.16)',
		'rgba(255,255,255,0.20)',
		'rgba(255,255,255,0.24)',
		'rgba(255,255,255,0.48)',
		'rgba(255,255,255,1.00)',
	],
	yellow: [
		'rgba(255,250,218,1.00)',
		'rgba(255,240,173,1.00)',
		'rgba(255,230,125,1.00)',
		'rgba(255,219,75,1.00)',
		'rgba(255,209,26,1.00)',
		'rgba(230,184,0,1.00)',
		'rgba(179,143,0,1.00)',
		'rgba(128,102,0,1.00)',
		'rgba(78,61,0,1.00)',
		'rgba(29,20,0,1.00)',
	],
};

export const chartColors = Object.keys(colors)
	.filter((c) =>
		[
			'blue',
			'cyan',
			'teal',
			'green',
			'lime',
			'primary',
			'yellow',
			'orange',
			'grape',
			'indigo',
		].includes(c)
	)
	.map((c) => colors[c][4]);

export const lightShades = {
	'border/ai-secondary/active': colors.violet[4],
	'border/ai-secondary/default': colors.violet[2],
	'border/ai-secondary/hover': colors.violet[3],
	'border/ai/default': colors.violet[1],
	'border/critical-secondary/default': colors.red[7],
	'border/critical/default': colors.red[2],
	'border/emphasis-secondary/active': colors.blue[4],
	'border/emphasis-secondary/default': colors.blue[2],
	'border/emphasis-secondary/hover': colors.blue[3],
	'border/emphasis/active': colors.blue[7],
	'border/emphasis/default': colors.blue[5],
	'border/emphasis/hover': colors.blue[6],
	'border/info/default': colors.cyan[2],
	'border/input/active': colors.gray[8],
	'border/input/default': colors.gray[6],
	'border/input/hover': colors.gray[7],
	'border/inverse/active': colors.gray[3],
	'border/inverse/default': colors.gray[7],
	'border/inverse/hover': colors.gray[5],
	'border/primary/default': colors.gray[4],
	'border/primary/disabled': colors.gray[3],
	'border/primary/hover': colors.gray[5],
	'border/secondary/active': colors.gray[5],
	'border/secondary/default': colors.gray[3],
	'border/secondary/hover': colors.gray[5],
	'border/secondary/selected': colors.gray[7],
	'border/tertiary/active': colors.gray[7],
	'border/tertiary/default': colors.gray[5],
	'border/tertiary/hover': colors.gray[6],
	'border/tertiary/selected': colors.gray[7],
	'border/transparent/default': colors['white-alpha'][9],
	'border/warning/default': colors.orange[1],
	'fill/ai-secondary/active': colors.violet[3],
	'fill/ai-secondary/default': colors.violet[1],
	'fill/ai-secondary/hover': colors.violet[2],
	'fill/ai/default': colors.violet[5],
	'fill/avatar/five': colors.cyan[1],
	'fill/avatar/four': colors.indigo[1],
	'fill/avatar/one': colors.grape[1],
	'fill/avatar/seven': colors.gray[3],
	'fill/avatar/six': colors.sunset[1],
	'fill/avatar/three': colors.lime[1],
	'fill/avatar/two': colors.teal[1],
	'fill/brand/active': colors.dark[8],
	'fill/brand/default': colors.gray[9],
	'fill/brand/disabled': colors['black-alpha'][5],
	'fill/brand/hover': colors.dark[7],
	'fill/brand/selected': colors.gray[9],
	'fill/caution-secondary/active': colors.yellow[3],
	'fill/caution-secondary/default': colors.yellow[1],
	'fill/caution-secondary/hover': colors.yellow[3],
	'fill/caution-secondary/selected': colors.yellow[3],
	'fill/caution/default': colors.yellow[4],
	'fill/critical-secondary/active': colors.red[3],
	'fill/critical-secondary/default': colors.red[1],
	'fill/critical-secondary/hover': colors.red[2],
	'fill/critical/active': colors.red[7],
	'fill/critical/default': colors.red[6],
	'fill/critical/hover': colors.red[6],
	'fill/critical/selected': colors.red[7],
	'fill/decorative/cyan': colors.cyan[1],
	'fill/decorative/grape': colors.grape[1],
	'fill/decorative/gray': colors.gray[4],
	'fill/decorative/indigo': colors.indigo[1],
	'fill/decorative/lime': colors.lime[1],
	'fill/decorative/sunset': colors.sunset[1],
	'fill/decorative/teal': colors.teal[1],
	'fill/emphasis-secondary/active': colors.blue[2],
	'fill/emphasis-secondary/default': colors.blue[0],
	'fill/emphasis-secondary/hover': colors.blue[1],
	'fill/emphasis/default': colors.blue[5],
	'fill/info-secondary/active': colors.cyan[3],
	'fill/info-secondary/default': colors.cyan[1],
	'fill/info-secondary/hover': colors.cyan[2],
	'fill/info/default': colors.cyan[3],
	'fill/inverse/active': colors.dark[4],
	'fill/inverse/default': colors.dark[7],
	'fill/inverse/hover': colors.dark[5],
	'fill/primary/active': colors.gray[2],
	'fill/primary/default': colors['white-alpha'][9],
	'fill/primary/disabled': colors['black-alpha'][2],
	'fill/primary/hover': colors.gray[1],
	'fill/primary/selected': colors.gray[5],
	'fill/secondary/active': colors.gray[4],
	'fill/secondary/default': colors.gray[2],
	'fill/secondary/hover': colors.gray[3],
	'fill/success-secondary/default': colors.green[1],
	'fill/success/default': colors.green[6],
	'fill/tertiary/active': colors.gray[5],
	'fill/tertiary/default': colors.gray[3],
	'fill/tertiary/hover': colors.gray[4],
	'fill/transparent-secondary/active': colors['black-alpha'][4],
	'fill/transparent-secondary/default': colors['black-alpha'][2],
	'fill/transparent-secondary/hover': colors['black-alpha'][3],
	'fill/transparent/active': colors['black-alpha'][3],
	'fill/transparent/default': colors['black-alpha'][0],
	'fill/transparent/hover': colors['black-alpha'][2],
	'fill/transparent/selected': colors['black-alpha'][3],
	'fill/warning-secondary/active': colors.orange[3],
	'fill/warning-secondary/default': colors.orange[1],
	'fill/warning-secondary/hover': colors.orange[2],
	'fill/warning/default': colors.orange[4],
	'icon/ai/default': colors.violet[4],
	'icon/brand/default': colors.gray[9],
	'icon/caution/default': colors.yellow[5],
	'icon/chart/1': colors.cyan[5],
	'icon/chart/10': colors.teal[6],
	'icon/chart/2': colors.indigo[3],
	'icon/chart/3': colors.sunset[3],
	'icon/chart/4': colors.teal[3],
	'icon/chart/5': colors.grape[3],
	'icon/chart/6': colors.lime[3],
	'icon/chart/7': colors.blue[3],
	'icon/chart/8': colors.yellow[4],
	'icon/chart/9': colors.pink[1],
	'icon/critical/default': colors.red[5],
	'icon/decorative/cyan': colors.cyan[5],
	'icon/decorative/grape': colors.grape[5],
	'icon/decorative/grey': colors.gray[8],
	'icon/decorative/indigo': colors.indigo[5],
	'icon/decorative/light grey': colors.gray[6],
	'icon/decorative/lime': colors.lime[5],
	'icon/decorative/orange': colors.orange[5],
	'icon/decorative/pink': colors.pink[5],
	'icon/decorative/sunset': colors.sunset[3],
	'icon/decorative/teal': colors.teal[5],
	'icon/decorative/violet': colors.violet[5],
	'icon/decorative/yellow': colors.yellow[5],
	'icon/emphasis/active': colors.blue[7],
	'icon/emphasis/default': colors.blue[5],
	'icon/emphasis/hover': colors.blue[6],
	'icon/info/default': colors.cyan[5],
	'icon/inverse-ai/default': colors.violet[3],
	'icon/inverse-secondary/default': colors.gray[6],
	'icon/inverse/default': colors.gray[3],
	'icon/nav/default': colors.gray[7],
	'icon/on-fill-decorative/cyan': colors.cyan[7],
	'icon/on-fill-decorative/grape': colors.grape[7],
	'icon/on-fill-decorative/indigo': colors.indigo[7],
	'icon/on-fill-decorative/lime': colors.lime[7],
	'icon/on-fill-decorative/sunset': colors.sunset[7],
	'icon/on-fill-decorative/teal': colors.teal[7],
	'icon/primary/active': colors.gray[9],
	'icon/primary/default': colors.gray[8],
	'icon/primary/disabled': colors.gray[5],
	'icon/primary/hover': colors.gray[9],
	'icon/secoda/default': colors.sunset[3],
	'icon/secondary/active': colors.gray[8],
	'icon/secondary/default': colors.gray[6],
	'icon/secondary/hover': colors.gray[7],
	'icon/success/default': colors.green[5],
	'icon/warning/default': colors.orange[5],
	'shadow/border': colors['black-alpha'][2],
	'shadow/border-ai': colors.violet[1],
	'shadow/button-default': colors.gray[4],
	'shadow/button-default-bottom': colors.gray[5],
	'shadow/button-shadow': colors['black-alpha'][9],
	'shadow/reflection': colors['white-alpha'][6],
	'surface/ai/active': colors.violet[2],
	'surface/ai/default': colors.violet[0],
	'surface/ai/hover': colors.violet[1],
	'surface/app/default': colors.gray[0],
	'surface/backdrop/default': 'rgba(0,0,0,0.20)',
	'surface/caution/active': colors.yellow[2],
	'surface/caution/default': colors.yellow[0],
	'surface/caution/hover': colors.yellow[1],
	'surface/critical/active': colors.red[2],
	'surface/critical/default': colors.red[0],
	'surface/critical/hover': colors.red[1],
	'surface/emphasis/active': colors.blue[2],
	'surface/emphasis/default': colors.blue[0],
	'surface/emphasis/hover': colors.blue[1],
	'surface/glass/medium': 'rgba(246,246,246,0.60)',
	'surface/glass/thick': 'rgba(246,246,246,0.72)',
	'surface/glass/thin': 'rgba(246,246,246,0.48)',
	'surface/glass/ultrathick': 'rgba(246,246,246,0.84)',
	'surface/glass/ultrathin': 'rgba(246,246,246,0.36)',
	'surface/info/active': colors.cyan[2],
	'surface/info/default': colors.cyan[0],
	'surface/info/hover': colors.cyan[1],
	'surface/input/active': colors.gray[3],
	'surface/input/default': colors.gray[0],
	'surface/input/hover': colors.gray[1],
	'surface/inverse/default': colors.dark[7],
	'surface/nav/default': colors.gray[1],
	'surface/primary/active': colors.gray[2],
	'surface/primary/default': colors['white-alpha'][9],
	'surface/primary/disabled': colors['black-alpha'][2],
	'surface/primary/hover': colors.gray[1],
	'surface/primary/selected': colors.gray[2],
	'surface/secondary/active': colors.gray[3],
	'surface/secondary/default': colors.gray[1],
	'surface/secondary/hover': colors.gray[2],
	'surface/secondary/selected': colors.gray[3],
	'surface/success/active': colors.green[2],
	'surface/success/default': colors.green[0],
	'surface/success/hover': colors.green[1],
	'surface/tertiary/active': colors.gray[4],
	'surface/tertiary/default': colors.gray[2],
	'surface/tertiary/hover': colors.gray[3],
	'surface/tertiary/selected': colors.gray[4],
	'surface/transparent/active': colors['black-alpha'][2],
	'surface/transparent/default': colors['black-alpha'][0],
	'surface/transparent/hover': colors['black-alpha'][1],
	'surface/transparent/selected': colors['black-alpha'][2],
	'surface/warning/active': colors.orange[2],
	'surface/warning/default': colors.orange[0],
	'surface/warning/hover': colors.orange[1],
	'text/ai-on-fill/default': colors['white-alpha'][9],
	'text/ai-secondary/default': colors.violet[5],
	'text/ai/default': colors.violet[6],
	'text/avatar/five-on-fill': colors.cyan[8],
	'text/avatar/four-on-fill': colors.indigo[8],
	'text/avatar/one-on-fill': colors.grape[8],
	'text/avatar/six-on-fill': colors.sunset[8],
	'text/avatar/three-on-fill': colors.lime[8],
	'text/avatar/two-on-fill': colors.teal[8],
	'text/brand-on-fill/active': colors.gray[5],
	'text/brand-on-fill/default': colors['white-alpha'][9],
	'text/brand-on-fill/disabled': colors['white-alpha'][9],
	'text/brand-on-fill/hover': colors.gray[3],
	'text/caution-on-fill/default': colors.yellow[8],
	'text/caution/default': colors.yellow[8],
	'text/code/attribute_name': colors.green[6],
	'text/code/attribute_value': colors.pink[6],
	'text/code/comment': colors.gray[7],
	'text/code/delimiter': colors.gray[7],
	'text/code/function': colors.orange[6],
	'text/code/identifier': colors.green[6],
	'text/code/identifier_function': colors.green[6],
	'text/code/keyword': colors.blue[5],
	'text/code/number': colors.grape[5],
	'text/code/operator': colors.blue[5],
	'text/code/string': colors.pink[5],
	'text/code/tag': colors.orange[6],
	'text/code/type': colors.grape[5],
	'text/code/type_identifier': colors.green[6],
	'text/critical-on-fill/active': colors.red[1],
	'text/critical-on-fill/default': colors['white-alpha'][9],
	'text/critical-on-fill/hover': colors.red[0],
	'text/critical/active': colors.red[9],
	'text/critical/default': colors.red[7],
	'text/critical/hover': colors.red[8],
	'text/emphasis-on-fill/default': colors['white-alpha'][9],
	'text/emphasis/active': colors.blue[7],
	'text/emphasis/default': colors.blue[5],
	'text/emphasis/hover': colors.blue[6],
	'text/info-on-fill/default': colors.cyan[8],
	'text/info/default': colors.cyan[8],
	'text/inverse-emphasis/active': colors.blue[1],
	'text/inverse-emphasis/default': colors.blue[3],
	'text/inverse-emphasis/hover': colors.blue[2],
	'text/inverse-secondary/default': colors.dark[1],
	'text/inverse/default': colors.gray[3],
	'text/nav/default': colors.gray[8],
	'text/primary/default': colors.gray[9],
	'text/primary/disabled': colors.gray[5],
	'text/secondary/default': colors.gray[7],
	'text/success-on-fill/default': colors['white-alpha'][9],
	'text/success/default': colors.green[8],
	'text/warning-on-fill/default': colors.orange[8],
	'text/warning/default': colors.orange[8],
};

export const darkShades: typeof lightShades = {
	'border/ai-secondary/active': colors.violet[3],
	'border/ai-secondary/default': colors.violet[2],
	'border/ai-secondary/hover': colors.violet[3],
	'border/ai/default': colors.violet[7],
	'border/critical-secondary/default': colors.red[5],
	'border/critical/default': colors.red[7],
	'border/emphasis-secondary/active': colors.blue[4],
	'border/emphasis-secondary/default': colors.blue[6],
	'border/emphasis-secondary/hover': colors.blue[5],
	'border/emphasis/active': colors.blue[5],
	'border/emphasis/default': colors.blue[5],
	'border/emphasis/hover': colors.blue[5],
	'border/info/default': colors.cyan[7],
	'border/input/active': colors.gray[5],
	'border/input/default': colors.gray[7],
	'border/input/hover': colors.gray[6],
	'border/inverse/active': colors.gray[8],
	'border/inverse/default': colors.gray[8],
	'border/inverse/hover': colors.gray[8],
	'border/primary/default': colors.dark[4],
	'border/primary/disabled': colors.dark[4],
	'border/primary/hover': colors.dark[4],
	'border/secondary/active': colors.dark[2],
	'border/secondary/default': colors.dark[4],
	'border/secondary/hover': colors.dark[3],
	'border/secondary/selected': colors.dark[3],
	'border/tertiary/active': colors.dark[5],
	'border/tertiary/default': colors.dark[5],
	'border/tertiary/hover': colors.dark[5],
	'border/tertiary/selected': colors.dark[5],
	'border/transparent/default': colors.dark[6],
	'border/warning/default': colors.orange[7],
	'fill/ai-secondary/active': colors.violet[5],
	'fill/ai-secondary/default': colors.violet[7],
	'fill/ai-secondary/hover': colors.violet[6],
	'fill/ai/default': colors.violet[5],
	'fill/avatar/five': colors.cyan[7],
	'fill/avatar/four': colors.indigo[7],
	'fill/avatar/one': colors.grape[7],
	'fill/avatar/seven': colors['white-alpha'][9],
	'fill/avatar/six': colors.sunset[7],
	'fill/avatar/three': colors.lime[7],
	'fill/avatar/two': colors.teal[7],
	'fill/brand/active': colors.dark[1],
	'fill/brand/default': colors.dark[0],
	'fill/brand/disabled': colors['white-alpha'][5],
	'fill/brand/hover': colors.dark[1],
	'fill/brand/selected': colors.dark[1],
	'fill/caution-secondary/active': colors.yellow[7],
	'fill/caution-secondary/default': colors.yellow[8],
	'fill/caution-secondary/hover': colors.yellow[7],
	'fill/caution-secondary/selected': colors.yellow[7],
	'fill/caution/default': colors.yellow[7],
	'fill/critical-secondary/active': colors.red[5],
	'fill/critical-secondary/default': colors.red[7],
	'fill/critical-secondary/hover': colors.red[6],
	'fill/critical/active': colors.red[5],
	'fill/critical/default': colors.red[7],
	'fill/critical/hover': colors.red[6],
	'fill/critical/selected': colors.red[5],
	'fill/decorative/cyan': colors.cyan[7],
	'fill/decorative/grape': colors.grape[7],
	'fill/decorative/gray': colors.dark[4],
	'fill/decorative/indigo': colors.indigo[7],
	'fill/decorative/lime': colors.lime[7],
	'fill/decorative/sunset': colors.sunset[7],
	'fill/decorative/teal': colors.teal[7],
	'fill/emphasis-secondary/active': colors.blue[6],
	'fill/emphasis-secondary/default': colors.blue[8],
	'fill/emphasis-secondary/hover': colors.blue[7],
	'fill/emphasis/default': colors.blue[6],
	'fill/info-secondary/active': colors.cyan[5],
	'fill/info-secondary/default': colors.cyan[7],
	'fill/info-secondary/hover': colors.cyan[6],
	'fill/info/default': colors.cyan[5],
	'fill/inverse/active': colors.dark[3],
	'fill/inverse/default': colors.dark[5],
	'fill/inverse/hover': colors.dark[4],
	'fill/primary/active': colors.dark[4],
	'fill/primary/default': colors.dark[5],
	'fill/primary/disabled': colors['white-alpha'][3],
	'fill/primary/hover': colors.dark[4],
	'fill/primary/selected': colors.dark[3],
	'fill/secondary/active': colors.dark[3],
	'fill/secondary/default': colors.dark[5],
	'fill/secondary/hover': colors.dark[4],
	'fill/success-secondary/default': colors.green[8],
	'fill/success/default': colors.green[7],
	'fill/tertiary/active': colors.dark[2],
	'fill/tertiary/default': colors.dark[4],
	'fill/tertiary/hover': colors.dark[3],
	'fill/transparent-secondary/active': colors['white-alpha'][4],
	'fill/transparent-secondary/default': colors['white-alpha'][2],
	'fill/transparent-secondary/hover': colors['white-alpha'][3],
	'fill/transparent/active': colors['white-alpha'][3],
	'fill/transparent/default': colors['white-alpha'][0],
	'fill/transparent/hover': colors['white-alpha'][2],
	'fill/transparent/selected': colors['white-alpha'][3],
	'fill/warning-secondary/active': colors.orange[5],
	'fill/warning-secondary/default': colors.orange[7],
	'fill/warning-secondary/hover': colors.orange[6],
	'fill/warning/default': colors.orange[7],
	'icon/ai/default': colors.violet[4],
	'icon/brand/default': colors.gray[4],
	'icon/caution/default': colors.yellow[4],
	'icon/chart/1': colors.cyan[5],
	'icon/chart/10': colors.teal[6],
	'icon/chart/2': colors.indigo[4],
	'icon/chart/3': colors.sunset[3],
	'icon/chart/4': colors.teal[5],
	'icon/chart/5': colors.grape[5],
	'icon/chart/6': colors.lime[5],
	'icon/chart/7': colors.blue[5],
	'icon/chart/8': colors.yellow[5],
	'icon/chart/9': colors.pink[3],
	'icon/critical/default': colors.red[4],
	'icon/decorative/cyan': colors.cyan[4],
	'icon/decorative/grape': colors.grape[4],
	'icon/decorative/grey': colors.gray[7],
	'icon/decorative/indigo': colors.indigo[4],
	'icon/decorative/light grey': colors.gray[7],
	'icon/decorative/lime': colors.lime[4],
	'icon/decorative/orange': colors.orange[4],
	'icon/decorative/pink': colors.pink[4],
	'icon/decorative/sunset': colors.sunset[3],
	'icon/decorative/teal': colors.teal[4],
	'icon/decorative/violet': 'rgba(255,255,255,1.00)',
	'icon/decorative/yellow': colors.yellow[4],
	'icon/emphasis/active': colors.blue[2],
	'icon/emphasis/default': colors.blue[4],
	'icon/emphasis/hover': colors.blue[3],
	'icon/info/default': colors.cyan[4],
	'icon/inverse-ai/default': colors.violet[5],
	'icon/inverse-secondary/default': colors.gray[3],
	'icon/inverse/default': colors.gray[3],
	'icon/nav/default': colors.dark[2],
	'icon/on-fill-decorative/cyan': colors.cyan[1],
	'icon/on-fill-decorative/grape': colors.grape[1],
	'icon/on-fill-decorative/indigo': colors.indigo[1],
	'icon/on-fill-decorative/lime': colors.lime[1],
	'icon/on-fill-decorative/sunset': colors.sunset[1],
	'icon/on-fill-decorative/teal': colors.teal[1],
	'icon/primary/active': colors.gray[3],
	'icon/primary/default': colors.gray[5],
	'icon/primary/disabled': colors.gray[6],
	'icon/primary/hover': colors.gray[4],
	'icon/secoda/default': colors.sunset[3],
	'icon/secondary/active': colors.gray[5],
	'icon/secondary/default': colors.gray[7],
	'icon/secondary/hover': colors.gray[6],
	'icon/success/default': colors.green[4],
	'icon/warning/default': colors.orange[3],
	'shadow/border': colors['white-alpha'][6],
	'shadow/border-ai': colors['white-alpha'][6],
	'shadow/button-default': colors.gray[7],
	'shadow/button-default-bottom': colors.gray[8],
	'shadow/button-shadow': colors['black-alpha'][6],
	'shadow/reflection': colors['white-alpha'][6],
	'surface/ai/active': colors.violet[6],
	'surface/ai/default': colors.violet[8],
	'surface/ai/hover': colors.violet[7],
	'surface/app/default': colors.dark[9],
	'surface/backdrop/default': 'rgba(0,0,0,0.60)',
	'surface/caution/active': colors.yellow[6],
	'surface/caution/default': colors.yellow[8],
	'surface/caution/hover': colors.yellow[7],
	'surface/critical/active': colors.red[6],
	'surface/critical/default': colors.red[8],
	'surface/critical/hover': colors.red[7],
	'surface/emphasis/active': colors.blue[6],
	'surface/emphasis/default': colors.blue[8],
	'surface/emphasis/hover': colors.blue[7],
	'surface/glass/medium': 'rgba(0,0,0,0.30)',
	'surface/glass/thick': 'rgba(0,0,0,0.40)',
	'surface/glass/thin': 'rgba(0,0,0,0.20)',
	'surface/glass/ultrathick': 'rgba(0,0,0,0.50)',
	'surface/glass/ultrathin': 'rgba(0,0,0,0.10)',
	'surface/info/active': colors.cyan[6],
	'surface/info/default': colors.cyan[8],
	'surface/info/hover': colors.cyan[7],
	'surface/input/active': colors.dark[4],
	'surface/input/default': colors.dark[6],
	'surface/input/hover': colors.dark[5],
	'surface/inverse/default': colors.dark[5],
	'surface/nav/default': colors.dark[7],
	'surface/primary/active': colors.dark[4],
	'surface/primary/default': colors.dark[6],
	'surface/primary/disabled': colors['white-alpha'][3],
	'surface/primary/hover': colors.dark[5],
	'surface/primary/selected': colors.dark[4],
	'surface/secondary/active': colors.dark[3],
	'surface/secondary/default': colors.dark[5],
	'surface/secondary/hover': colors.dark[4],
	'surface/secondary/selected': colors.dark[3],
	'surface/success/active': colors.green[7],
	'surface/success/default': colors.green[8],
	'surface/success/hover': colors.green[7],
	'surface/tertiary/active': colors.dark[3],
	'surface/tertiary/default': colors.dark[7],
	'surface/tertiary/hover': colors.dark[6],
	'surface/tertiary/selected': colors.dark[3],
	'surface/transparent/active': colors['white-alpha'][0],
	'surface/transparent/default': colors['white-alpha'][0],
	'surface/transparent/hover': colors['white-alpha'][0],
	'surface/transparent/selected': colors['white-alpha'][0],
	'surface/warning/active': colors.orange[6],
	'surface/warning/default': colors.orange[8],
	'surface/warning/hover': colors.orange[7],
	'text/ai-on-fill/default': colors.gray[9],
	'text/ai-secondary/default': colors.violet[1],
	'text/ai/default': colors.violet[1],
	'text/avatar/five-on-fill': colors.cyan[1],
	'text/avatar/four-on-fill': colors.indigo[1],
	'text/avatar/one-on-fill': colors.grape[1],
	'text/avatar/six-on-fill': colors.sunset[1],
	'text/avatar/three-on-fill': colors.lime[1],
	'text/avatar/two-on-fill': colors.teal[1],
	'text/brand-on-fill/active': colors.dark[4],
	'text/brand-on-fill/default': colors.dark[6],
	'text/brand-on-fill/disabled': colors.dark[6],
	'text/brand-on-fill/hover': colors.dark[5],
	'text/caution-on-fill/default': colors.gray[9],
	'text/caution/default': colors.yellow[2],
	'text/code/attribute_name': colors.green[3],
	'text/code/attribute_value': colors.pink[3],
	'text/code/comment': colors.dark[1],
	'text/code/delimiter': colors.gray[3],
	'text/code/function': colors.orange[3],
	'text/code/identifier': colors.green[3],
	'text/code/identifier_function': colors.green[3],
	'text/code/keyword': colors.blue[3],
	'text/code/number': colors.grape[3],
	'text/code/operator': colors.blue[3],
	'text/code/string': colors.pink[3],
	'text/code/tag': colors.orange[3],
	'text/code/type': colors.grape[3],
	'text/code/type_identifier': colors.green[3],
	'text/critical-on-fill/active': colors.gray[9],
	'text/critical-on-fill/default': colors.gray[9],
	'text/critical-on-fill/hover': colors.gray[9],
	'text/critical/active': colors.red[3],
	'text/critical/default': colors.red[3],
	'text/critical/hover': colors.red[3],
	'text/emphasis-on-fill/default': colors.gray[9],
	'text/emphasis/active': colors.blue[0],
	'text/emphasis/default': colors.blue[2],
	'text/emphasis/hover': colors.blue[1],
	'text/info-on-fill/default': colors.gray[9],
	'text/info/default': colors.cyan[1],
	'text/inverse-emphasis/active': colors.blue[1],
	'text/inverse-emphasis/default': colors.blue[3],
	'text/inverse-emphasis/hover': colors.blue[2],
	'text/inverse-secondary/default': 'rgba(255,255,255,1.00)',
	'text/inverse/default': colors.gray[4],
	'text/nav/default': colors.dark[2],
	'text/primary/default': colors.gray[3],
	'text/primary/disabled': colors.dark[3],
	'text/secondary/default': colors.dark[2],
	'text/success-on-fill/default': colors.gray[9],
	'text/success/default': colors.green[1],
	'text/warning-on-fill/default': colors.gray[9],
	'text/warning/default': colors.orange[2],
} as const;
